import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {Image} from "react-bootstrap";
import dashboardImage from "../../../assets/img/dashboard.webp";
import {Card} from "../common/Card";
import appname from "../../../appname";
import {routes} from "../../../routes";
import {BookCallModal} from "../common/BooKCallModal";
import {I18nService} from "../../../service/i18nService";

export const EnterpriseDMARC = () => {
    const {t} = useTranslation();
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <article>
                <title>{t('pages.enterpriseDmarc.meta.title')}</title>
                <meta name={"description"} content={t('pages.enterpriseDmarc.meta.description')}></meta>
                {currentLang === 'en' &&
                    <link rel="canonical"
                          href={appname + "/" + currentLang + "/" + routes["enterpriseEmailProtectionWithDmarc"]["en"]}/>}
                {currentLang === 'de' &&
                    <link rel="canonical"
                          href={appname + "/" + currentLang + "/" + routes["enterpriseEmailProtectionWithDmarc"]["de"]}/>}
                <link rel="alternate"
                      href={appname + "/" + currentLang + "/" + routes["enterpriseEmailProtectionWithDmarc"]["en"]}
                      hrefLang="en"/>
                <link rel="alternate"
                      href={appname + "/" + currentLang + "/" + routes["enterpriseEmailProtectionWithDmarc"]["de"]}
                      hrefLang="de"/>
                <link rel="alternate"
                      href={appname + "/" + currentLang + "/" + routes["enterpriseEmailProtectionWithDmarc"]["en"]}
                      hrefLang="x-default"/>
            </article>

            <div className="container">
                {/* Hero Section */}
                <div className="row align-items-center justify-content-between flex-column-reverse flex-lg-row py-5"
                     id="hero">
                    <div className="col px-4 mb-4 mb-lg-0 text-center text-lg-start">
                        <h1 dangerouslySetInnerHTML={{__html: t("pages.enterpriseDmarc.title")}}></h1>
                        <p className="lead mb-3">{t("pages.enterpriseDmarc.description")}</p>
                    </div>
                    <div className="col px-4 d-flex justify-content-center">
                        <div
                            className="col-12 col-md-10 col-lg-8 d-flex align-items-center justify-content-center">
                            <Image src={dashboardImage} alt="dashboard" className="img-fluid"/>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center justify-content-between flex-column-reverse flex-lg-row py-5">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold display-5">{t("pages.enterpriseDmarc.whyEnterprise.title")}</h2>
                        <p className="lead text-muted">{t("pages.enterpriseDmarc.whyEnterprise.subtitle")}</p>
                    </div>
                    <div className="row g-4">
                        {[
                            {key: "bullet1", icon: "🌐"},
                            {key: "bullet2", icon: "🤝"},
                            {key: "bullet3", icon: "🚀"},
                            {key: "bullet4", icon: "📊"},
                            {key: "bullet5", icon: "🛡️"},
                        ].map((item, index) => (
                            <div className="col-md-6" key={index}>
                                <div className="d-flex align-items-start p-4 bg-white rounded-4 shadow-sm h-100">
                                    <div className="fs-3 me-3">{item.icon}</div>
                                    <div>
                                        <p className="fw-semibold mb-1">
                                            {t(`pages.enterpriseDmarc.whyEnterprise.${item.key}`).split("–")[0]}
                                        </p>
                                        <p className="text-muted mb-0">
                                            {t(`pages.enterpriseDmarc.whyEnterprise.${item.key}`).split("–")[1]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-5">
                        <button className="btn btn-primary btn-lg rounded-pill px-5 text-white"
                                onClick={() => setShowModal(true)}>
                            {t("pages.enterpriseDmarc.whyEnterprise.cta")}
                        </button>
                    </div>
                </div>

                <BookCallModal show={showModal} handleClose={() => setShowModal(false)}/>

                {/* Why Us Section */}
                <div className="row py-5 px-4 bg-light" id="why-us">
                    <div className="col mx-auto text-center" style={{maxWidth: "1000px"}}>
                        <h2>{t("pages.enterpriseDmarc.whyUs.title")}</h2>
                        <p className="mb-4">{t("pages.enterpriseDmarc.whyUs.description")}</p>
                        <div className="row row-cols-1 row-cols-md-3 g-4">
                            <div className="col">
                                <Card
                                    title={t("pages.enterpriseDmarc.whyUs.cards.expertSupport.title")}
                                    features={t("pages.enterpriseDmarc.whyUs.cards.expertSupport.features")}
                                    iconClass="bi bi-people-fill text-success"
                                />
                            </div>
                            <div className="col">
                                <Card
                                    title={t("pages.enterpriseDmarc.whyUs.cards.visualReports.title")}
                                    features={t("pages.enterpriseDmarc.whyUs.cards.visualReports.features")}
                                    iconClass="bi bi-bar-chart-fill text-info"
                                />
                            </div>
                            <div className="col">
                                <Card
                                    title={t("pages.enterpriseDmarc.whyUs.cards.fullPrivacy.title")}
                                    features={t("pages.enterpriseDmarc.whyUs.cards.fullPrivacy.features")}
                                    iconClass="bi bi-lock-fill text-danger"
                                />
                            </div>
                        </div>
                        <button className="btn btn-secondary text-white mt-4" onClick={() => setShowModal(true)}>
                            {t("pages.enterpriseDmarc.whyUs.cta")}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
